import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/site/Header";
import Footer from "../components/site/Footer";
import Breadcrumbs from "../components/site/Breadcrumbs";
import { useSeo } from "../hooks/useSeo";
import { INFO_PAGES } from "../data/sitePages";
import { breadcrumb } from "../lib/jsonld";

export default function InfoPage({ slug }) {
  const navigate = useNavigate();
  const page = INFO_PAGES[slug];
  const crumbs = [{ name: "Home", path: "/" }, { name: page.h1, path: `/${page.slug}` }];

  useSeo({
    title: page.title,
    description: page.description,
    path: `/${page.slug}`,
    jsonLd: [breadcrumb(crumbs)],
  });

  return (
    <div data-testid={`info-page-${slug}`} className="bg-brand-bg text-brand-ink">
      <Header onNavigate={() => navigate("/")} />
      <article className="mx-auto max-w-[820px] px-6 pt-40 pb-24 md:px-10">
        <Breadcrumbs items={crumbs} />
        <h1 className="font-display mt-6 text-4xl leading-tight text-brand-ink md:text-5xl">{page.h1}</h1>
        <div className="mt-8 space-y-8">
          {page.body.map((block, i) => (
            <section key={i}>
              {block.h && <h2 className="font-display text-2xl text-brand-ink">{block.h}</h2>}
              <p className={`text-lg text-brand-inkSoft ${block.h ? "mt-3" : ""}`}>{block.p}</p>
            </section>
          ))}
        </div>
      </article>
      <Footer />
    </div>
  );
}
